// Vite entry. React 19 concurrent root + i18n boot before App mounts so the
// first paint already speaks the default language (tr-TR). No OIDC / auth /
// data layer — this is a public, static marketing SPA.

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import "@/styles/globals.css";
import { App } from "@/App";
import { initI18n } from "@/i18n";

async function bootstrap(): Promise<void> {
  const i18n = await initI18n();

  // Sync <html lang> + document.title with the resolved locale so screen
  // readers pronounce content correctly (WCAG 2.2 — 3.1.1 Language of Page).
  const syncDocumentLocale = (lng: string): void => {
    document.documentElement.lang = lng;
    document.title = i18n.t("app.document_title");
  };
  syncDocumentLocale(i18n.language);
  i18n.on("languageChanged", syncDocumentLocale);

  const container = document.getElementById("root");
  if (!container) {
    throw new Error("website: #root element missing from index.html");
  }

  createRoot(container).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

void bootstrap();
